import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../../models/user.model';
import { SessionService } from '../../services/session.service';
import { AuthService } from '../../services/auth.service';

declare var jQuery: any;

@Component({
  selector: 'app-layout-navbar-menu',
  templateUrl: './layout-navbar-menu.component.html',
  styleUrls: ['./layout-navbar-menu.component.css']
})
export class LayoutNavbarMenuComponent implements OnInit {

  user: User;
  contractSelect: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _authService: AuthService,
    private _sessionService: SessionService
  ) { }

  ngOnInit() {

    this.setUser();
    this._sessionService.changeContractObservable.asObservable().subscribe(
      value => {
        if (value) {
          this.setUser();
        }

      }
    )
  }

  private setUser(): void {
    this.contractSelect = this._sessionService.getSelectContract();
    this.user = this._sessionService.getCurrentUser();
  }

  openMenuProfile() {
    document.getElementById("mySidenav").style.width = "100%";
  }

  closeMenuProfile() {
    document.getElementById("mySidenav").style.width = "0";
  }

  toggleSidebar() {
    jQuery('.app-sidebar').addClass('active');
    jQuery('.app-container').addClass('__sidebar');
  }

  profile() {
    this.closeMenuProfile();
    this.router.navigate(['/office/profile']);
  }

  homeOffice() {
    this.router.navigate(['/office/home']);
  }

  signOut() {
    this._authService.logOut();
  }

}



// WEBPACK FOOTER //
// /app/src/app/shared/components/layout-navbar-menu/layout-navbar-menu.component.ts